.subscriptionIcon {
    height: 100%;
    width: 100%;
}
